import React from "react";

import { Table } from "components/Common/clearsense-ui/components";

import { COLUMN_DATA } from "./constants";

const Results = ({
  result,
  setSelectedFile,
  setShowModal,
  isValleyChildren,
}) => {
  const handleRowClick = selectedRow => {
    setSelectedFile(selectedRow);
    setShowModal(true);
  };
  return (
    <div className="ml-4 cs-ui-container__table w-[70%]">
      <Table
        columnData={COLUMN_DATA(isValleyChildren)}
        rowData={result}
        rowKey={record => record.key}
        onRowClick={(_, selectedRow) => handleRowClick(selectedRow)}
        data-cy="result-table"
        scroll={{ y: "calc(100vh - 260px)" }}
      />
    </div>
  );
};

export default Results;
